// March 2014

/* global extKey */

/** Constructor
    Optionally takes a format[] array which defines labels
      and an optional a helper function.
 */
function SelectionSet(format) {
  this.selection = {};
  if (typeof(format) !== undefined) {
    this.format = format;
  }
}

/* update(records) adds or removes records for the selection
   could do client-side vectors
   Adding update() to the prototype means that it will only exist
   once regardless of how many instances of SelectionSet exist
 */
SelectionSet.prototype.update = function(records) {
  let record
  let key
  let len = records.length
  let count = 0
  if (!extKey.shiftKey) { // clear the selection and start fresh
    this.selection = {};  // this should be taken care of in infoToolHandler() now
    for (let i = 0; i < len; i++) {    // for (record in records) {
      record = records[i];
      key = '"_' + record[0] + '"';
      this.selection[key] = record;
      count++;
    } // for (records)
  } else if (extKey.shiftKey) { // manipulating an existing rwg.selection.ownership set
    // loop thru the records[] and copy each record into
    // this.selection {} if it's not in there already or
    // if it is already there remove it (toggle)
    for (let i = 0; i < len; i++) {
      record = records[i];
      key = '"_' + record[0] + '"';
      // if ( this.selection.hasOwnProperty(key) && !rwg.dragging) {  // toggle out existing selection BUT ONLY IF point NOT box
      if (this.selection.hasOwnProperty(key) && rwg.selection.method !== 'box') { // toggle out existing selection BUT ONLY IF point NOT box
        delete this.selection[key];
      } else {
        this.selection[key] = record;
      }
    }
    for (key in this.selection) {
      if (this.selection.hasOwnProperty(key)) {
        count++;
      }
    }
    extKey.shiftKey = false
  }

  /*
  if (typeof this.updateHistory === 'function') {
    this.updateHistory();
  }
  */
  return count;
} // update()

/* render() - Renders JSON data for display in the Info Tool.
    Processes all records for given layer.
    Optionally takes a format[] array which defines labels
    and an optional a helper function.
    The format[] array should preferably be defined in the
    SelectionSet constructor but supported here for compatibility.
    Returns a <div>.
    *
    * there is  formatInfo.js:rwg.formatInfo()  that does pretty much the same thing as this does
    *
*/
SelectionSet.prototype.render = function(format, heading, footer) {
  // The format should really be passed in the constructor, this is a kluge
  if (typeof(this.format) === 'undefined') {
    this.format = format;
  }

  /* removed 2023-10-22
  if (typeof rwg.hiliteMethod === 'string' &&
      rwg.hiliteMethod === 'vector' &&
      typeof OpenLayers === 'object'   // OpenLayers 2
     ) {
    lyrVector.removeAllFeatures();
  } */

  /*
    The selection looks like:
      _id: {
        [record],
        [records]
      }
    but formatInfo() needs:
      [
        [record],
        [records]
      ]
    http://stackoverflow.com/questions/6857468/a-better-way-to-convert-js-object-to-array
  */
  const selection = this.selection // make this.selection available inside function below
  const records = Object.keys(selection).map( key => selection[key])

  return rwg.formatInfo(records, this.format, heading, footer)
}

SelectionSet.prototype.getIdArray = function() {
  let ids = []
  for (const key in this.selection) {
    ids.push("'" + key.slice(2, -1) + "'")  // strip off the '"_' prefix and replace double quotes with single
  }
  return ids
}

SelectionSet.prototype.clear = function() {
  this.update([])
}

/*
SelectionSet.prototype.updateHistory = function() {
  // console.log('update selection history', this.format[0][0] + '=' + this.getIdArray() );
  // this.format[0][0] may be undefied 1st time around becasue 1st call to render() sets it in some cases

  console.log('update selection history', this.getIdArray() );
  // rwg.filter = "(pidn in(" + rwg.selection.ownership.getIdArray().join(",") + "))";
  // rwg.historyManager.push();
}
*/

export {SelectionSet as default};
